import { Injectable, OnDestroy } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
// import { StepAdditional, StepFnItem } from './step.additional.interface';

@Injectable({
  providedIn: 'root'
})
export class StepperObserverService implements OnDestroy {
    private steps = 0;

    private stepperSubject =
        new BehaviorSubject<{ step: number, last: boolean }>(
                { step: null, last: false }
        );
    private stepperChanges = this.stepperSubject.asObservable();
    private stepperSub: Subscription;

    constructor() {}

    ngOnDestroy(): void {
       this.stepperSub.unsubscribe();
    }

    listen(
        stepper: MatStepper,
        // events: Map<string, number>
    ): Observable<{ step: number, last: boolean }> {

        this.steps = stepper._steps.length - 1;

        this.stepperSub = stepper.selectionChange.subscribe(
            (generatorOrNext: any) => {
                const step = generatorOrNext.selectedIndex;
                const last = (this.steps === step);

                this.stepperSubject.next({ step, last });
            },
            (error: Error) => {
                console.error('Error to listen stepper change');
                console.error(error);
            }
        );

        return this.stepperChanges;
    }

    eventSearcher(
        step: number,
        events: Map<string, number>
    ): { name: string, id: number } | null {

        let result: any = null;

        events.forEach((value: number, key: string) => {
            if (step === value) {
                result = { name: key, id: value };
            }
        });

        return result;
    }
}
